import React, { useId } from 'react';
import './styles.scoped.css';

const FormTextField = ({
  label,
  required = false,
  error,
  errorMessage,
  loading = false,
  disabled = false,
  type = 'text',
  className = '',
  style = {},
  ...rest
}) => {
  const fieldId = useId();
  const errorId = `${fieldId}-error`;

  return (
    <div className={`form-text-field ${className}`} style={style}>
      {label && (
        <label htmlFor={fieldId} className={`label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <div className="input-wrapper">
        <div className="input-row">
          <input
            id={fieldId}
            className={`input ${error ? 'input-error' : ''}`}
            type={type}
            disabled={disabled}
            aria-required={required || undefined}
            aria-invalid={!!error || undefined}
            aria-describedby={error ? errorId : undefined}
            {...rest}
          />
          {loading && <span className="spinner" />}
        </div>
        {error && errorMessage && (
          <span id={errorId} className="error-message">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  );
};

export default FormTextField;
